import { render, staticRenderFns } from "./UserProfileDetailAccount.vue?vue&type=template&id=5b732940&scoped=true&"
import script from "./UserProfileDetailAccount.vue?vue&type=script&lang=js&"
export * from "./UserProfileDetailAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b732940",
  null
  
)

export default component.exports